import {
    deleteAccount,
    getUserMe,
    login,
    requestVerificationCode,
    resetPassword
} from "../../services/AuthenticationService";
import * as StorageService from "../../services/StorageServices";
import { LOCALSTORAGE_ITEMS } from "../../util/Constants";

export const loginHandler = async (username, password) => {
    const response = await login(username, password);

    if (response.ok) {
        StorageService.setItem(LOCALSTORAGE_ITEMS.USERNAME, username);
        StorageService.setItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN, response.data.access_token);
        StorageService.setItem(LOCALSTORAGE_ITEMS.REFRESH_TOKEN, response.data.refresh_token);
    }

    return {
        data: {
            error: response.ok ? null : "Error login"
        }
    };
}

export const getCurrentUserHandler = async () => {
    const response = await getUserMe();

    if (!response?.ok || !response?.data) {

        StorageService.removeItem(LOCALSTORAGE_ITEMS.COMPANY_INFO);
       

        return {
            data: {
                user: null,
                error: "Error Getting Current User...",
            },
        };
    }

    const data = response.data;

    const clockingLocations = data?.employee?.clockingLocations ?? [];
 
    StorageService.setItem(LOCALSTORAGE_ITEMS.ACCOUNT_INFO, JSON.stringify(data));
    StorageService.setItem(LOCALSTORAGE_ITEMS.FIRST_NAME, data.firstName ?? "");
    StorageService.setItem(LOCALSTORAGE_ITEMS.LAST_NAME, data.lastName ?? "");
    StorageService.setItem(LOCALSTORAGE_ITEMS.USER_ID, data.id ?? "");
   


    StorageService.setItem(LOCALSTORAGE_ITEMS.TYPE, data.type ?? "");


    if (data.company) {
        StorageService.setItem(
            LOCALSTORAGE_ITEMS.COMPANY_INFO,
            JSON.stringify(data.company)
        );
    } else {
        StorageService.removeItem(LOCALSTORAGE_ITEMS.COMPANY_INFO);
    }

    return {
        data: {
            user: {
                id: data.id,
                firstName: data.firstName,
                lastName: data.lastName,
                phone: data.phone,
                type: data.type,
                company: data.company ?? null,
                companyId: data.companyId ?? data.company?.id ?? null,
            },
            error: null,
        },
    };
};



export const resetPasswordHandler = async (phone, validCode, newPassword, newPasswordConfirmation) => {
    const response = await resetPassword(phone, validCode, newPassword, newPasswordConfirmation);
    if (!response.ok) {
        return {
            data: {
                error: "Error resetPasswordHandler",
                errorCode: response.data.errorCode,
                message: response.data.message
            }
        }
    }

    return {
        data: {
            error: null,
        }
    };
}


export const requestVerificationCodeHandler = async (phone) => {
    const response = await requestVerificationCode(phone);
    if (!response.ok) {
        return {
            data: {
                error: "Error requestVerificationCodeHandler",
                errorCode: response.data.errorCode,
                message: response.data.message
            }
        }
    }

    return {
        data: {
            error: null,
        }
    };
}


export const deleteAccountHandler = async () => {
    const response = await deleteAccount();
    if (!response.ok) {
        return {
            data: {
                error: "Error deleteAccountHandler",
                errorCode: response.data.errorCode,
                message: response.data.message
            }
        }
    }

    return {
        data: {
            error: null,
        }
    };
}









